import Page from '../components/ui/Page';
import ContentLayout from '../layouts/ContentLayout';

const IndexPage = () => {
  return (
    <Page>
      <ContentLayout heading="Simple Pricing.">
        <h1 className="mt-10 text-green-600">Zero Dollars.</h1>
        <h4 className="mt-2">While in beta.</h4>
        <div className="mt-2 font-black">Enjoy.</div>
        <div className="mt-2 mb-10 text-6xl">💸</div>
      </ContentLayout>
    </Page>
  );
};

export default IndexPage;
